import React from "react";

export default function MSAccess_Month() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Month</h1>
      <p>This is the MSAccess_Month component generated from the SQL JSON.</p>
    </div>
  );
}
